import { render, staticRenderFns } from "./BindFeaturesView.vue?vue&type=template&id=2a3cfac0"
import script from "./BindFeaturesView.vue?vue&type=script&lang=js"
export * from "./BindFeaturesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports